<template>
  <div>
    <v-data-table :items="initialFiles" hide-actions hide-headers v-if="initialFiles.length"
                  no-data-text="No hay datos disponibles">
      <template slot="items" slot-scope="props">
        <tr class="row-element" :key="props.item.asset.id">
          <td><a :href="props.item.asset.url" target="_blank">{{ props.item.asset.name }}</a></td>
          <td>{{ props.item.uploadDate }}</td>
          <td class="text-xs-left">{{ props.item.asset.description }}</td>
          <td class="text-xs-right">
            <v-btn icon @click="remove(props.item)" :disabled="!requerimiento.canModifyAttachments && !props.item.canBeModified">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <p class="red--text" v-for="error in fileErrors" :key="error">{{ error }}</p>
    <AttachFile ref="fileInput" :description="true" @upload="uploadFiles"></AttachFile>
    <v-btn @click="openFileDirectory" color="#1787c9" dark class="attach-button">
      <v-icon>attach_file</v-icon>
      <span>Agregar Adjuntos</span>
    </v-btn>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../../common/ui/AttachFile'

export default {
  props: {
    requerimiento: Object,
    isFicha: Boolean
  },

  components: {
    AttachFile
  },

  mixins: [validationMixin],

  validations () {
    return {
      files: {
        required: requiredIf(() => {
          return this.doesNotHavePreviousAttachments() && !this.hasAddedFiles() && !this.isLoading() && !this.requerimiento.optional
        })
      }
    }
  },

  data () {
    return {
      files: [],
      removedFiles: [],
      initialFiles: [],
      loading: false
    }
  },

  computed: {
    fileErrors () {
      const errors = []
      if (!this.$v.files.$dirty) return errors
      !this.$v.files.required && errors.push('Adjunto requerido.')
      return errors
    }
  },

  methods: {
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    remove (item) {
      const index = this.initialFiles.indexOf(item)
      this.removedFiles.push(this.initialFiles[index].pk)
      this.initialFiles.splice(index, 1)
      this.initialFiles = [...this.initialFiles]
    },
    isValid () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    isModified () {
      return (this.files.length > 0) || (this.removedFiles.length > 0)
    },
    isLoading () {
      return this.loading
    },
    doesNotHavePreviousAttachments () {
      return (this.requerimiento.adjuntos.length === 0) || ((this.initialFiles.length === 0) && this.isFicha)
    },
    hasAddedFiles () {
      return this.files.length > 0
    },
    hasRemovedFiles () {
      return this.removedFiles.length > 0
    },
    getAddedFiles () {
      return this.files
    },
    getRemovedFiles () {
      return this.removedFiles
    },
    getModifiedFiles () {
      return []
    },
    cleanAddedFiles () {
      this.$refs.fileInput.cleanContent()
      this.files = []
    },
    cleanRemovedFiles () {
      this.removedFiles = []
    },
    cleanModifiedFiles () {},
    assignInitialFiles () {
      if (this.isFicha) {
        this.initialFiles = this.requerimiento.adjuntos.slice()
      } else {
        this.initialFiles = this.requerimiento.adjuntos
      }
    },
    startLoading () {
      this.loading = true
    },
    finishLoading () {
      this.loading = false
    }
  },

  watch: {
    'requerimiento.adjuntos' () {
      this.assignInitialFiles()
    }
  },

  created () {
    this.assignInitialFiles()
  }
}
</script>

<style scoped>
a {
  color: #1787c9;
}
.attach-button {
  font-size:0.9em;
  padding-left: 0.6em;
}
.row-element {
  background-color: #f0f0f2;
}
</style>
